export default {
  title: 'Toimitustiedot',
  buttons: {
    save: 'Tallenna',
  },
};
